export default {
  createContent: {
    pageTitle: "Register new Work",
    pageDescription: "Submit your creative Works to protect ownership rights",
    pageKeywords:
      "copyright protection, intellectual property, content protection, AI monitoring, legal enforcement, digital rights management, creator protection, content licensing",

    protectedWithWatermark: "• Protected with watermark",
    withWatermark: "With watermark",
    processingWatermark: "Processing watermark for the image...",

    steps: {
      upload: "Upload",
      info: "Information",
      distribution: "Distribution",
      protection: "Protection",
      confirm: "Confirm",
    },
    fields: {
      contentKind: "Work Type",
      uploadTitle: "Upload Work",
      selectedFile: "Selected {{count}} file",
      selectedFile_other: "Selected {{count}} files",
      title: "Work Title",
      titlePlaceholder: "Type your Work title",
      description: "Description",
      descriptionPlaceholder: "Detailed description of the work",
      descriptionNote: "{{length}}/1000 characters",
      // category: "Category",
      // selectCategory: "Select category",
      // tags: "Tags",
      isPublic: "Display in public catalog",
      isPublicHelp:
        "If selected, your work will be displayed in the public catalog and can be searched by potential buyers",
      collaboratorsEmpty: "No collaborators have been added.",
      collaboratorsHelp:
        "You will be listed as the sole creator with 100% ownership.",
      addCollaborator: "Add Collaborator",
      collaboratorName: "Name",
      collaboratorEmail: "Email",
      collaboratorShare: "Distribution Share (%)",
      totalDistribution: "Total distribution share:",
      totalDistributionError: "Total distribution share must equal 100%.",
      minioTotalSize: "Total Size",
      minioPath: "MinIO path",
      minioSize: "Size",
      minioProtected: "Protection",
      protection: {
        title: "Protection Measures",
        description:
          "Choose protection measures for your work. \nProtection measures help prevent unauthorized use and enhance your ownership protection.",
        watermark: "Automatic Watermark",
        watermarkDesc:
          "Add a digital watermark to your work to prevent unauthorized copying.",
        aiMonitoring: "AI Monitoring",
        aiMonitoringDesc:
          "Use AI to scan and detect copyright violations across online platforms.",
        blockchain: "Blockchain Certification",
        blockchainDesc:
          "Register your work on blockchain to verify ownership and authenticity.",
        score: "Estimated Protection Score",
        scoreHelp:
          "Protection score indicates how well your work is protected. Higher score means better protection.",
        protectionScore: "Protection Score",
      },
      confirmation: {
        title: "All information is ready!",
        description:
          'Please review your work information and click "Register" to complete.',
        workInfo: "Work Information",
        collaboratorInfo: "Collaborators",
        protectionInfo: "Protection Measures",
        minioInfo: "MinIO Storage Status",
        noteValidateTerms: "Please agree to both terms above to proceed with the verification.",
        terms: "I agree to the Terms and Conditions",
        ownership:
          "I confirm that I have the right to register copyright for this work",
        on: "On",
        off: "Off",
      },
    },
    success: {
      title: "Registration Successful!",
      description: "Your work has been registered successfully and is pending approval.",
      viewAll: "View All Works",
      registerAnother: "Register Another Work"
    },
    message: {
      validationTitle: "Please check and correct the following errors",
      requiredTitle: "Required Information",
      invalidTitle: "Invalid Information",
      incompleteErrorsTitle: "Incomplete Information",
      errorContentKindRequired: "Please select a content type.",
      errorFileRequired: "Please upload at least one file.",
      errorTitleRequired: "Title cannot be empty.",
      errorTitleInvalid: "The title is invalid or must contain more than 5 characters.",
      errorCategoryRequired: "Please select a category.",
      errorDescriptionInvalid: "The description must not exceed 1000 characters.",
      errorTermsRequired: "Please agree to the terms to continue.",
      errorTermsAgreed: "Please agree to the terms of use",
      errorOwnershipAgreed: "Please confirm ownership of the work",
      errorRegisterWorkFailed: "Work registration failed"
    },
  },

  contentManagement: {
    pageTitle: "Catalog Management",
    pageDescription: "Displaying {{value}}/{{total}} works",
    pageKeywords: "copyright protection, intellectual property, content protection, AI monitoring, legal enforcement, digital rights management, creator protection, content licensing",
    view: {
      issuedCertificates: "Issued certificates ({{count}})",
      applicationForms: "Applications ({{count}})",
      issuingAgency: "Issuing agency",
      issueDate: "Issue date",
      expiryDate: "Expiry date",
      verificationCode: "Verification code",
    }
  },
  
  works: {
    pageTitle: "Community Works List",
    pageDescription: "Explore {{total}} copyright-protected works from the community",
    pageKeywords:
      "copyright protection, intellectual property, content protection, AI monitoring, legal enforcement, digital rights management, creator protection, content licensing",
    statistics: {
      totalWorks: 'Total Works',
      totalViews: 'Total Views',
      totalLikes: 'Total Likes',
      avgProtection: 'Average Protection'
    }
  },

  updateMetadata: {
    pageTitle: "Update Metadata",
    pageDescription: "Edit detailed information and files of the work",
    pageKeywords: "copyright protection, intellectual property, content protection, AI monitoring, legal enforcement, digital rights management, creator protection, content licensing",

    basicInfo: "Basic Information",
    workInfo: "Work Information",
    workTitle: "Work Title",
    mainTitle: "Main Title of the Work",
    description: "Description",
    workDescription: "Detailed description of the work",
    addKeywords: "Add keywords to help others find the work",
    
    manageFiles: "Manage Files",
    currentFiles: "Current Files",
    newFile: "New File",
    newFilesWillBeAdded: "New files will be added",
    changeSummary: "Change Summary",
    addNewFilesCount: "Add {{count}} new file",
    addNewFilesCount_other: "Selected {{count}} files",
    deleteFilesCount: "Delete {{count}} existing file",
    deleteFilesCount_other: "Delete {{count}} existing files",
    changeDescription: "Change Description",
    changeDescriptionPlaceholder: "Describe the changes you made...",
    changeDescriptionRequired: "Please describe the changes you made",
    currentVersion: "Current version: v{{ver}}"
  },

  publishing: {
    pageTitle: "Content Publishing",
    pageDescription: "Manage and publish certified content to the marketplace",
    pageKeywords: "copyright protection, intellectual property, content protection, AI monitoring, legal enforcement, digital rights management, creator protection, content licensing",

    certifiedContent: "Certified Content",
    publishedOnMarketplace: "Published on Marketplace",
    notPublished: "Not Published",
    publishingRate: "Publishing Rate",
    searchTermPlaceholder: "Search by name...",
    dataEmpty: "Register your content to start selling on the marketplace",
    dataNotFound: "Try adjusting filters or search keywords",

    modal: {
      title: "Publish your work on the Marketplace",
      shortDescription: "Short description for the Marketplace",
      featured: "Suggest as a featured Work",
      licenseOptions: "License and Pricing Options",
      alertLicenseOptions: "There are no license templates in the system. Please contact the administrator.",
      licenses:{
        standardLicense: {
          title: "Standard License",
          description: "Basic license for non-commercial use"
        },
        note: "At least one license type must be activated",
      }
    }
  },
  
  contentDetail: {
    pageTitle: "Content detail",
    pageKeywords: "copyright protection, intellectual property, content protection, AI monitoring, legal enforcement, digital rights management, creator protection, content licensing",
  }
};
